import Vue from 'vue';
import { Component } from 'vue-property-decorator';
const Leftnav = require('./leftnav/leftnav.vue.html');
const Search = require('../components/search/search.vue.html');
const Overlay = require('../components/overlay/overlay.vue.html');

@Component({
    components: {
        Leftnav,
        Search,
        Overlay
    }
})
export default class PortalHome extends Vue {
    drawer: boolean = false;
    search: boolean = false;   

    get isAuthenticated() {
        return this.$store.getters.isAuthenticated;
    }

    logout() {
        this.$store.dispatch('logout');
        this.$router.push('/login');
    }

    mounted() {
        this.$store.dispatch('loadSecurityRoles');
        this.$store.dispatch('loadRefData');      

    }
}



// WEBPACK FOOTER //
// ./ClientApp/src/portalhome/portalhome.ts